import { IconWrapper } from '../runtime';
export default IconWrapper('link_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.21921 3.46564C8.53259 3.15059 8.91202 2.9424 9.31268 2.84106C10.0933 2.64362 10.9546 2.85181 11.5652 3.46564C12.4892 4.39452 12.4892 5.90054 11.5652 6.82942L10.048 8.35457C9.12397 9.28342 7.6259 9.28343 6.70193 8.35458L7.67735 7.37394C8.06262 7.76124 8.68727 7.76124 9.07253 7.37394L10.5898 5.84879C10.975 5.46149 10.9751 4.83356 10.5898 4.44627C10.2781 4.13292 9.80972 4.07309 9.43819 4.26676C8.92519 3.99642 8.35036 3.87774 7.77756 3.90962",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.79487 10.5281C6.87089 11.457 5.37283 11.457 4.44885 10.5281C3.52488 9.59923 3.52486 8.09324 4.44881 7.16436L5.96568 5.63919C6.88899 4.71099 8.38558 4.71028 9.30972 5.63713L8.33429 6.61775C7.94886 6.23248 7.32573 6.23316 6.94114 6.61978L5.42431 8.14491C5.03906 8.5322 5.03901 9.16017 5.42427 9.54747C5.73564 9.86049 6.20338 9.92053 6.57474 9.72757C7.09136 9.9962 7.66976 10.1117 8.2452 10.0753L7.79487 10.5281Z",
      "fill": "white"
    }
  })]);
});